import styles from "../../styles/shared/other-coins-signal/OtherCoins.module.css";
import { IoMdArrowDropright } from "react-icons/io";
import SelectExchange from "../SelectExchange";
import SelectedAssetsList from "./SelectedAssetsList";
import SearchCoins from "./SearchCoins";
import Watchlists from "./Watchlists";
import SelectAssets from "./SelectAssets";
import { Button, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { analyzeOtherCoins } from "../../redux/analyze-other-coins/otherCoinsAnalyzeSlice";
import useFetchAllExchangesWithCoins from "../../hooks/api/useFetchAllExchangesWithCoins";
import capitalize from "antd/es/_util/capitalize";
import {
  WEEKLY_PORTFOLIO_URL,
  normalizeWeeklyPortfolio,
} from "./watchlistCoins";

function OtherCoinsConfigs({
  handleExchangeChange,
  selectedExchange,
  selectedSymbols,
  setSelectedSymbols,
  searchedCoin,
  setSearchedCoin,
  selectedWatchlist,
  setSelectedWatchlist,
  setStep,
  controllerRef,
}) {
  const {
    exchangeState: {
      exchangesLoading,
      allExchangesWithCoinsStatus,
      allExchangesWithCoins,
    },
    otherCoinsAnalyze: { status },
    main: { userData },
    tradingAssistant: { aiMarketType },
  } = useSelector((state) => state);

  const dispatch = useDispatch();
  const [weeklyPortfolio, setWeeklyPortfolio] = useState({
    core: [],
    tactical: [],
  });

  useEffect(() => {
    let cancelled = false;
    fetch(WEEKLY_PORTFOLIO_URL)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (!cancelled && data) {
          setWeeklyPortfolio(normalizeWeeklyPortfolio(data));
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const { exchangeList: allExchanges } = useFetchAllExchangesWithCoins();

  const loadingMessage =
    status === "loading"
      ? "Fetching signals..."
      : exchangesLoading
        ? "Fetching exchanges..."
        : "";

  const assets =
    allExchangesWithCoins
      ?.find(
        (item) =>
          item?.exchange?.toLowerCase() === selectedExchange?.toLowerCase(),
      )
      ?.coins?.map((coinData) => coinData?.Coin) || [];

  const handleSubmit = () => {
    if (status === "loading") return;

    const coins = selectedSymbols?.map((symbol) => {
      if (symbol?.toLowerCase()?.includes("/usdt")) {
        return symbol;
      } else {
        return `${symbol}/USDT`;
      }
    });

    controllerRef.current = new AbortController();
    const { signal } = controllerRef.current;

    dispatch(
      analyzeOtherCoins(
        userData?.["custom:custom_username"],
        userData?.["cognito:username"],
        aiMarketType,
        coins,
        selectedExchange?.toLowerCase(),
        signal,
      ),
    );
    setStep(2);
  };

  useEffect(() => {
    if (!selectedExchange && allExchanges.length > 0) {
      handleExchangeChange(capitalize(allExchanges?.[0]));
    }
  }, [allExchanges, handleExchangeChange, selectedExchange]);

  return (
    <>
      <div className={styles.box}>
        <h4>Select an Exchange</h4>
        <SelectExchange
          value={selectedExchange}
          onChange={handleExchangeChange}
          loading={status === "loading"}
          style={{ width: "100%" }}
          useCase="ai-assistant"
        />
      </div>

      <div className={styles.box}>
        <h4>Choose Assets</h4>
        <div className={styles.coins}>
          {selectedSymbols?.length > 0 && (
            <SelectedAssetsList
              selectedAssets={selectedSymbols}
              changeSelectedAssets={setSelectedSymbols}
            />
          )}
          <SearchCoins
            selectedCoins={selectedSymbols}
            disabled={!selectedExchange}
            searchValue={searchedCoin}
            setSearchValue={setSearchedCoin}
          />
        </div>

        {selectedExchange && (
          <>
            <Watchlists
              assets={assets}
              selectedWatchlist={selectedWatchlist}
              setSelectedWatchlist={setSelectedWatchlist}
              weeklyPortfolio={weeklyPortfolio}
            />
            <SelectAssets
              selectedAssets={selectedSymbols}
              changeSelectedAssets={setSelectedSymbols}
              selectedWatchlist={selectedWatchlist}
              selectedExchange={selectedExchange}
              searchedCoin={searchedCoin}
              weeklyPortfolio={weeklyPortfolio}
            />
          </>
        )}
      </div>

      <div className={styles.footer}>
        {!allExchangesWithCoins.length &&
          allExchangesWithCoinsStatus === "loading" && (
            <div className={styles.loader}>
              <Spin size="small" />
              <p>{loadingMessage}</p>
            </div>
          )}

        <Button
          onClick={handleSubmit}
          loading={status === "loading"}
          className={styles.submitButton}
          disabled={!selectedSymbols.length || !selectedExchange}
        >
          {status === "error" ? "Retry" : "Confirm"}
        </Button>
      </div>
    </>
  );
}

export default OtherCoinsConfigs;
